import * as React from "react";
import {useState} from "react";
import {useDataProvider, useNotify, useRefresh} from "react-admin";
import {TextField as MuiTextField, IconButton} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

export const EditableStockField = ({record}) => {
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(record?.quantityInStock ?? '');
    const [saving, setSaving] = useState(false);
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    if (!record) return null;

    const display = record.quantityInStock !== null && record.quantityInStock !== undefined
        ? record.quantityInStock
        : "Illimité";

    const startEdit = (e) => {
        e.stopPropagation();
        setValue(record.quantityInStock ?? '');
        setEditing(true);
    };

    const cancel = (e) => {
        e?.stopPropagation();
        setEditing(false);
        setValue(record.quantityInStock ?? '');
    };

    const save = async (e) => {
        e?.stopPropagation();
        const trimmed = String(value).trim();
        const newStock = trimmed === '' ? null : Number(trimmed);

        if (trimmed !== '' && (Number.isNaN(newStock) || newStock < 0 || !Number.isInteger(newStock))) {
            notify("Stock invalide (entier ≥ 0 ou vide)", "warning");
            return;
        }
        const current = record.quantityInStock ?? null;
        if (newStock === current) {
            setEditing(false);
            return;
        }

        setSaving(true);
        try {
            const {data: full} = await dataProvider.getOne('products', {id: record.id});
            await dataProvider.update('products', {
                id: record.id,
                data: {...full, quantityInStock: newStock},
                previousData: full,
            });
            notify("Stock mis à jour", "info");
            setEditing(false);
            refresh();
        } catch (err) {
            notify("Erreur lors de la mise à jour : " + (err?.message ?? "inconnue"), "warning");
        } finally {
            setSaving(false);
        }
    };

    if (!editing) {
        return (
            <span style={{display: 'inline-flex', alignItems: 'center'}}>
                <span>{display}</span>
                <IconButton
                    size="small"
                    onClick={startEdit}
                    style={{marginLeft: 4}}
                    aria-label="Éditer le stock"
                >
                    <EditIcon fontSize="small"/>
                </IconButton>
            </span>
        );
    }

    return (
        <span
            style={{display: 'inline-flex', alignItems: 'center'}}
            onClick={(e) => e.stopPropagation()}
        >
            <MuiTextField
                type="number"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') save(e);
                    if (e.key === 'Escape') cancel(e);
                }}
                disabled={saving}
                size="small"
                style={{width: 90}}
                placeholder="vide = ∞"
                autoFocus
                inputProps={{min: 0, step: 1}}
            />
            <IconButton size="small" onClick={save} disabled={saving} aria-label="Enregistrer">
                <CheckIcon fontSize="small"/>
            </IconButton>
            <IconButton size="small" onClick={cancel} disabled={saving} aria-label="Annuler">
                <CloseIcon fontSize="small"/>
            </IconButton>
        </span>
    );
};
